import * as React from 'react';
import { useChainId, useSwitchChain } from 'wagmi';
import bnbLogo from '../images/bnb-bnb-logo.svg';

export function SwitchNetwork({ validChain }) {
  const chainId = useChainId();
  const { chains, switchChain } = useSwitchChain();

  let isValidChain = chainId === validChain?.id;

  async function switchNetworkClick() {
    if (validChain && switchNetworkAsync) {
      await switchChain({ chainId: validChain.id });
    }
  }

  return (
    <>
      <section aria-label="Ethos Login Box" className="Ethos-login">
        <div className="em-loginbox">
          <h1 className='bf-netdetect'>Unsupported Network</h1>
          <hr />
          <p className="ethosHeroExp text-clickToConnect">
            <img src={bnbLogo} width={25} height={25} alt="" className="bf-avax-logo" /> 
            <strong>Binance Smart Chain</strong> is the only supported network. Make sure to switch your wallet to BSC Mainnet</p>
          <div className="bf-netBtnSect">
            <button className="dr-btn2 cursor-pointer" onClick={switchNetworkClick} disabled={isValidChain}>Switch to BSC</button>
          </div>
        </div>
      </section>
    </>
  )
}

